var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenFolder = function SvgOpenFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1254A1",
    d: "M2.333 13.333q-.384 0-.692-.308t-.308-.692V3.667q0-.384.308-.692.309-.309.692-.308h4.683l1 1h5.65q.384 0 .692.308.309.308.308.692H7.583l-1-1h-4.25v8.666l1.7-6.666h11.633l-1.783 6.9q-.1.399-.367.583-.266.183-.683.183zm1.05-1h9.533l1.4-5.666H4.783z"
  })));
};
export default SvgOpenFolder;